let React = require('react');
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';

let TableFooter = React.createClass({

    calcularMonto: function (monto, novedades, cuenta) {
        let limiteObj = novedades.find(x => x.CuentaTarjetaId == cuenta.Id);
        if (limiteObj) {
            let limiteCompra = this.props.data.limiteCompra.find(x => x.Id == limiteObj.ValorNovedad);
            if (!limiteCompra) {
                limiteCompra = this.props.data.limiteCompra.find(x => x.Valor == limiteObj.ValorNovedad);
                monto = limiteCompra.Valor;
            }
            else {
                monto = limiteCompra.Valor;
            }
        }
        return monto;
    },

    render: function () {
        let limiteCuentaFormato;
        let limiteCuenta;
        let empresaSeleccionada2 = this.props.data.selectEnterpriseId;
        let novedad = this.props.data.novedadesEmpresas.find(x => x.EmpresaId == this.props.data.selectEnterpriseId);
        if (novedad !== undefined) {
            limiteCuenta = novedad.ValorNovedad;
        } else {
            let empresaSeleccionada = this.props.data.empresas.find(x => x.Id == this.props.data.selectEnterpriseId);
            if (this.props.data.empresas.length > 0) {
                if (empresaSeleccionada == undefined) {
                    empresaSeleccionada = this.props.data.empresas[0];
                    empresaSeleccionada2 = empresaSeleccionada.Id;
                }

                novedad = this.props.data.novedadesEmpresas.find(x => x.EmpresaId == empresaSeleccionada.Id);
                if (novedad !== undefined)
                    limiteCuenta = novedad.ValorNovedad;
                else
                    limiteCuenta = empresaSeleccionada.LimiteCompra;
            }
        }

        let novedades = this.props.data.novedadesCuentas;
        let novedadesEditadas = this.props.data.novedadesCuentas;
        let cuentas = this.props.data.cuentas;
        let label = "";
        if (cuentas !== undefined) {
            for (var i = 0; i < cuentas.length; i++) {
                let monto = cuentas[i].Valor;
                if (novedades !== undefined) {
                    monto = this.calcularMonto(monto, novedades, cuentas[i]);
                }
                if (novedadesEditadas !== undefined) {
                    monto = this.calcularMonto(monto, novedadesEditadas, cuentas[i]);
                }
                if (cuentas[i].EmpresaId == (empresaSeleccionada2)) {
                    limiteCuenta = limiteCuenta - parseInt(monto);
                }
                else {
                    if (cuentas[i].EmpresaVisaId == (empresaSeleccionada2)) {
                        limiteCuenta = limiteCuenta - parseInt(monto);
                    }
                }
            }

            limiteCuentaFormato = GlobalHelper.ConvertirNumeroSinDecimales(limiteCuenta);

            if (limiteCuenta > 0) {
                label = "Límite de la Cuenta sin asignar:";
            } else {
                label = "Límite sobreasignado";
            }
        }

        return (
            <div className="row">
                <div className="col-md-2">
                </div>
                <div className="col-md-4">
                    <label className="label-secondary">{label}</label>
                </div>
                <div className="col-md-6">
                    <label className="label-secondary">${limiteCuentaFormato}</label>
                </div>
            </div>
        );
    },
});

export default TableFooter